import { Component } from "react";
import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "styled-bootstrap-grid";
import { media } from "styled-bootstrap-grid";

import Content from "../organisms/Content";
import "../../images/icons.css";
import Page from "../organisms/Page";
import HeadShot from "../../images/fwolf_avatar.avif";
import Footer from "../organisms/Footer";

const AvatarImage = styled.img`
  width: 60%;
  margin-top: 0px;
  margin-left: 20%;

  ${media.lg`
    width: 100%;
    margin-left: 32px;
    padding-right: 32px;
  `}
`;

const AvatarImageWrap = styled.div`
  padding-bottom: 40px;
  padding-right: 48px;
  padding-top: 10px;

  ${media.lg`
    padding-bottom: 0px;
  `}
`;

const ContainerStyled = styled(Container)`
  min-height: calc(100vh - 284px);
`;

const ColStyled = styled(Col)`
  padding-bottom: 0;
`;

const RowStyled = styled(Row)`
  padding-bottom: 0;
  align-content: center;

  ${media.lg`
    min-height: calc(100vh - 284px);
  `}
`;

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bioContent: "", // Store loaded bio.html content here
    };
  }

  componentDidMount() {
    // Fetch the bio.html content dynamically
    fetch("/contentFragments/bio.html")
      .then((res) => res.text())
      .then((html) => {
        this.setState({ bioContent: html });
      })
      .catch((err) => console.error("Error loading bio:", err));
  }

  render() {
    return (
      <Page>
        <Content padded={true}>
          <div className="content--inner">
            <ContainerStyled justifyContent={"center"}>
              <RowStyled>
                <ColStyled col={12} lg={8}>
                  <div dangerouslySetInnerHTML={{ __html: this.state.bioContent }} />
                </ColStyled>
                <ColStyled col={12} lg={4} order={"first"} lgOrder={"first"}>
                  <AvatarImageWrap>
                    <AvatarImage src={HeadShot} alt="Florian Wolf" />
                  </AvatarImageWrap>
                </ColStyled>
              </RowStyled>
            </ContainerStyled>
          </div>
        </Content>
        <Footer />
      </Page>
    );
  }
}

export default About;